import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../lib/utils';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

// Radix Select is unreliable on touch devices (dropdown covers the screen and
// taps on options are not registered). On coarse-pointer devices we render a
// native <select>, which opens the OS picker wheel and always works.
const isTouchDevice = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(pointer: coarse)').matches;

export const HybridSelect = ({ value, onValueChange, options, placeholder, className, testId }) => {
  const [touch] = useState(isTouchDevice);

  if (touch) {
    return (
      <div className="relative w-full">
        <select
          value={value || ''}
          onChange={(e) => onValueChange(e.target.value)}
          data-testid={testId}
          className={cn(
            'flex h-9 w-full appearance-none items-center rounded-md border border-input bg-transparent px-3 py-2 pr-8 text-sm text-white focus:outline-none focus:ring-1 focus:ring-ring',
            !value && 'text-muted-foreground',
            className
          )}
        >
          <option value="" disabled hidden>
            {placeholder}
          </option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value} className="bg-black text-white">
              {opt.label}
            </option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 opacity-50" />
      </div>
    );
  }

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={cn('w-full', className)} data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="bg-card border-white/10 max-h-60">
        {options.map((opt) => (
          <SelectItem key={opt.value} value={opt.value}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
